import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { BookOpen, Loader2, Trash2, Upload } from "lucide-react";
import { catalogUrl, deleteCatalog, fetchCatalogs, uploadCatalog } from "@/lib/bf";

export default function BFCatalogs({ cfg }) {
  const [list, setList] = useState([]);
  const [meta, setMeta] = useState({ brand: "medavita", group: "", title: "" });
  const [pct, setPct] = useState(null);
  const file = useRef(null);
  useEffect(() => { fetchCatalogs().then(setList).catch(() => {}); }, []);
  const groups = [...new Set(cfg.products.filter((p) => p.brand === meta.brand && p.group).map((p) => p.group))];
  const name = (id) => cfg.brands.find((b) => b.id === id)?.name || id;
  const upload = async () => {
    const f = file.current?.files?.[0];
    if (!f || !meta.title.trim()) return toast.error("Alege PDF-ul și scrie un titlu");
    if (f.type !== "application/pdf" && !/\.pdf$/i.test(f.name)) return toast.error("Doar fișiere PDF");
    setPct(0);
    try {
      const doc = await uploadCatalog({ ...meta, title: meta.title.trim() }, f, setPct);
      setList((l) => [...l, doc]);
      setMeta({ ...meta, title: "" });
      file.current.value = "";
      toast.success("Catalog încărcat");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Încărcarea a eșuat");
    }
    setPct(null);
  };
  const remove = (id) => deleteCatalog(id).then(() => setList((l) => l.filter((x) => x.id !== id)));
  return (
    <section className="invite-box" data-testid="bfa-catalogs">
      <h3>Cataloage virtuale de nuanțe (PDF)</h3>
      <p className="st-hint">Apar pe pagina brandului și lângă fiecare gamă, la „Catalog nuanțe”. Alege gama ca să apară exact la vopseaua respectivă.</p>
      <div className="bfa-cat-form">
        <select value={meta.brand} onChange={(e) => setMeta({ ...meta, brand: e.target.value, group: "" })} data-testid="bfa-cat-brand">
          {cfg.brands.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <select value={meta.group} onChange={(e) => setMeta({ ...meta, group: e.target.value })} data-testid="bfa-cat-group">
          <option value="">Toate gamele brandului</option>
          {groups.map((g) => <option key={g} value={g}>{g}</option>)}
        </select>
        <input placeholder="Titlu, ex: Catalog nuanțe Luxviva" value={meta.title} maxLength={120} onChange={(e) => setMeta({ ...meta, title: e.target.value })} data-testid="bfa-cat-title" />
        <input ref={file} type="file" accept="application/pdf,.pdf" data-testid="bfa-cat-file" />
        <button type="button" className="st-btn st-btn--light" onClick={upload} disabled={pct !== null} data-testid="bfa-cat-upload">
          {pct !== null ? <><Loader2 size={14} className="animate-spin" /> {pct}%</> : <><Upload size={14} /> Încarcă</>}
        </button>
      </div>
      <ul className="bfa-leads">
        {list.map((x) => (
          <li key={x.id} data-testid={`bfa-cat-${x.id}`}>
            <div><b>{x.title}</b><span>{name(x.brand)}{x.group ? ` · ${x.group}` : ""} · {x.size < 1048576 ? `${Math.max(1, Math.round(x.size / 1024))} KB` : `${(x.size / 1048576).toFixed(1)} MB`}</span></div>
            <div className="interested-actions">
              <a className="st-btn st-btn--ghost" href={catalogUrl(x.id)} target="_blank" rel="noopener noreferrer"><BookOpen size={13} /> Deschide</a>
              <button type="button" className="bfa-del" onClick={() => remove(x.id)} aria-label="Șterge" data-testid={`bfa-cat-del-${x.id}`}><Trash2 size={15} /></button>
            </div>
          </li>
        ))}
        {!list.length && <li className="st-hint">Niciun catalog încărcat încă.</li>}
      </ul>
    </section>
  );
}
